export enum SidebarTitlesEnum {
	GUIDE_HEALTH = 'Guia médico',
	GUIDE_ODONTO = 'Guia odonto',
	MY_FINANCIALS = 'Meu financeiro',
	MY_DOCUMENTS = 'Meus documentos',
	PRESCRIPTION = 'Receituário',
	MY_EXAMS = 'Meus exames',
	MY_APPOINTMENTS = 'Meus agendamentos',
	HOME = 'Início',
	PERKS_CLUB = 'Clube de vantagens',
	EXAM_RESULTS = 'Resultado de exames',
}

export enum MyAppointmentsTitleEnum {
	MY_APPOINTMENTS = 'Agendamentos',
	MY_APPOINTMENTS_HISTORY = 'Histórico',
}

export enum MyDocumentsTitleEnum {
	STATEMENTS = 'Declarações',
	CERTIFICATES = 'Atestados',
	REQUESTS = 'Solicitações',
}

export enum PrescriptionTitleEnum {
	PRESCRIPTIONS = 'Receituário',
	PRESCRIPTION_DETAILS = 'Receitas',
	REMINDERS = 'Lembretes',
}

export enum MyPaymentsTitleEnum {
	OPEN_BILLS = 'Em aberto',
	PAYMENTS_HISTORY = 'Histórico de pagamentos',
	INCOME_TAX = 'Imposto de renda',
	COPARTICIPATION = 'Extrato de coparticipação',
}

export enum MyExamsTitleEnum {
	UPCOMING_EXAMS = 'Próximos exames',
}
